import React, { Component } from 'react'
import './style.css'

class Magazines extends Component {
  render () {
    return (
      <div className='magazines-main-container'>
        <div className='magazines-title-div'>
          <h1 className='magazines-main-title'>Magazines</h1>
          <img src='https://i.imgur.com/gZBy00w.png' className='car-photo-magazines' alt='' />
        </div>
        <div className='magazines-info-container'>
          <img
            src='https://i.imgur.com/AZpE0YA.png'
            alt='Free Download Line Png Images'
            className='line'
          />
          <div className='magazines-container'>
            <div className='magazines-info-container'>
              <p className='magazines-text'>
                <span className='magazines-span-title-text'>Poetry, prose and essays by Annabel Lee have appeared in many fine journals including:</span><br /><br />
                <span className='magazines-span-italic'> Positive Magnets</span> (edited by Collin Schuster) <br /><br />
                <span className='magazines-span-italic'>  Have Your Chill</span> (edited by Pete Spence: Melbourne, Australia) <br /><br />
                <span className='magazines-span-italic'> Dodgems</span> (edited by Eileen Myles) <br /><br />
                <span className='magazines-span-italic'> The Poetry Project Newsletter, Title/One, Lazy Fair</span> (Philadelphia) <br /><br />
                <span className='magazines-span-italic'> Caesura</span> (Philadelphia) <br /><br />
                <span className='magazines-span-italic'> WB <br /><br />Attaboy <br /><br />The New Time <br /><br />Ladies Museum <br /><br />Red M <br /><br />432 Review <br /><br />Dark Horse</span> (Boston) <br /><br />
                <span className='magazines-span-italic'> Mag City <br /><br />Assassin <br /><br />Hanging Loose <br /><br />Telephone</span> (edited by Maureen Owen) <br /><br />
                <span className='magazines-span-italic'> The Coldspring Journal</span> (edited by Charlie Plymell) <br /><br />
                <span className='magazines-span-italic'> Fresh Paint</span> (edited by Yuki Hartman and Michael Slater) <br /><br />
                “…?” (edited by Armando Pajalich, Gianantonio Pozzi, Rita Degli Esposti: Venice, Italy) <br /><br />
                <span className='magazines-span-italic'> The Poets’ Encyclopedia</span> (edited by Michael Andre) <br /><br />
                <span className='magazines-span-italic'> Saturday Morning</span> (edited by Simon Pettet) <br /><br />
                <span className='magazines-span-italic'> Bombay Gin</span> (Boulder) <br /><br />
                <span className='magazines-span-italic'> Sitting Frog</span> (Bouder) <br /><br />
                <span className='magazines-span-italic'> Little Caesar</span> (Los Angeles) <br /><br />
                <span className='magazines-span-italic'> Exquisite Corpse</span> (edited by Andrei Codrescu: Baton Rouge) <br /><br />
                <span className='magazines-span-italic'> Creel</span> <br /><br />
                <span className='magazines-span-italic'> North</span>, (edited by Ugo Pitozzi: Rome, Italy) <br /><br />
                <span className='magazines-span-italic'> Abracadabra</span> (edited by Marcello Angioni: Luxembourg) <br /><br />
                <span className='magazines-span-italic'> Sperlonga-Manhattan Express</span>
                (Riva San Vitale, Switzerland) <span className='magazines-span-italic'> Live Mag</span> (edited by Jeff Wright) <br /><br />
                <span className='magazines-span-italic'> DianeRavitch.net</span>
                <br /><br /><em>as well as other great magazines and in anthologies</em>
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Magazines
